<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <router-link :to="{ path: '/history' }">
            &lt;&lt;&lt; Return to History List
          </router-link>
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            History Detail
          </h1>
        </CCol>
      </CRow>
      <div class="content">
        <!-- <CRow>
          <div class="col-12">
            <label class="textarea-input" for="input-service-id">Original Document:</label>
            <input ref="originaldoc" class="mb-2 sm-input" type="file" accept=".doc, .docx, .pdf" @change="onInputOriginalDoc">
          </div>
          <div class="col-12 mt-3">
            <label class="textarea-input" for="input-service-id">Document(s) to Compare:</label>
            <input ref="comparedoc" class="mb-2 sm-input" type="file" multiple accept=".doc, .docx, .pdf" @change="onInputCompareDocs">
          </div>
          <CCol cols="12" class="form-button text-right mt-4">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
              </div>
            </div>
          </CCol>
        </CRow> -->
      </div>
      <CRow class="mt-5" v-if="resultCompare.length > 0">
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            COMPARISON RESULT
          </h4>
        </CCol>
      </CRow>
      <div v-if="isShowResults" class="content">
        <CRow>
          <CCol cols="12" class="comparison-result-desc form-button">
            <h6>Original Document: {{ result.filename }}</h6>
            <h6>Compared Document: {{ result.compared_filename.join(", ") }}</h6>
            <h6>Uploaded At: {{ result.created_at }}</h6>
            <h6>Analyzed At: {{ result.finished_at }}</h6>
            <h6 v-if="result.status == '2'">Analysis Result: Document Failed to Analyze</h6>
          </CCol>
        </CRow>
        <CRow v-if="resultCompare.length > 0">
          <CCol cols="12">
            <b-tabs v-model="activeTab" class="comparison-tabs" nav-class="comparison-tabs-list content-compact">
              <b-tab v-for="(doc, index) in resultCompare" :key="'result-doc-' + index" :title="'Result ' + (index+1)" title-link-class="comparison-tab-header">
                <template #title>
                  <span v-if="doc.isLoading"><b-spinner class="comparison-tab-spinner"></b-spinner> Loading...</span>
                  <span v-else>Result {{ index + 1}}</span>
                </template>
                <div class="mt-4" v-if="doc.isLoading || doc.error.length > 0">
                  <div v-if="doc.isLoading" class="text-center content-compact">
                    <b-spinner class="comparison-result-spinner" variant="primary"></b-spinner>
                  </div>
                  <div v-else-if="doc.error.length > 0">
                    <CRow class="content-compact">
                      <CCol cols="12">
                        <h6>Original Document: {{ doc.file1 }}</h6>
                        <h6>Compared Document: {{ doc.file2 }}</h6>
                        <hr>
                      </CCol>
                    </CRow>
                    <div class="text-center my-2 content-compact">
                      <h3 class="comparison-result-error">
                        ANALYSIS FAILED: <br>
                        {{ doc.error }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <CRow class="mt-4 content-compact">
                    <CCol cols="12" class="comparison-result-desc">
                      <h6>Original Document: <a v-if="doc.urlFile1" :href="doc.urlFile1" target="_blank">{{ doc.file1 }}</a><span v-else>{{ doc.file1 }}</span></h6>
                      <h6>Compared Document: <a v-if="doc.urlFile2" :href="doc.urlFile2" target="_blank">{{ doc.file2 }}</a><span v-else>{{ doc.file2 }}</span></h6>
                      <h6 v-if="doc.message">Analysis Result: {{ doc.message }}</h6>
                      <!-- <a v-if="doc.url" :href="$fileUrl + doc.url" target="_blank">Download Comparison Results</a> -->
                      <hr>
                    </CCol>
                  </CRow>
                  <div class="comparison-result-details">
                    <CRow class="mb-2 content-compact">
                      <CCol cols="12" class="d-flex justify-content-center my-2">
                        <h3 class="page-greetings">
                          Result {{ doc.score }}% match
                        </h3>
                      </CCol>
                    </CRow>
                    <b-tabs v-if="doc.score < 100" pills align="right" nav-class="content-compact">
                      <b-tab title="Highlight" active>
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.url" target="_blank">Download Comparison Results</a>
                        </div>
                        <div v-for="(page, i) in doc.pages" :key="'result-page-' + i" class="mb-4">
                          <div class="comparison-result-page">
                            <h4>Page {{ i + 1 }}</h4>
                            <h5>{{ page.score }}% match</h5>
                            <!-- <p>{{ page.status }}</p> -->
                          </div>
                          <b-table
                            v-if="page.differences.length > 0"
                            :fields="fields"
                            :items="page.differences"
                            bordered
                          >
                            <template #cell(index)="row">
                              <span>{{ row.index + 1 }}</span>
                            </template>
                            <template #cell(before)="row">
                              ...<span v-html="row.item.before"></span>...
                            </template>
                            <template #cell(after)="row">
                              ...<span v-html="row.item.after"></span>...
                            </template>
                          </b-table>
                        </div>
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.url" target="_blank">Download Comparison Results</a>
                        </div>
                      </b-tab>
                      <b-tab title="Inline">
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.urlInline" target="_blank">Download Comparison Results</a>
                        </div>
                        <div v-for="(page, i) in doc.inline" :key="'result-inline-' + i" class="mb-4">
                          <div class="comparison-result-page">
                            <h4>Page {{ i + 1 }}</h4>
                            <b-table
                              :fields="fieldsInline"
                              :items="page"
                              class="custom-table-document"
                              striped
                              :tbody-tr-class="rowType"
                            >
                              <template #cell(index)="row">
                                <pre>{{ row.index + 1 }}</pre>
                              </template>
                              <template #cell(contents)="row">
                                <pre v-html="row.item.contents"></pre>
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.urlInline" target="_blank">Download Comparison Results</a>
                        </div>
                      </b-tab>
                      <b-tab title="Side by side">
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.urlSide" target="_blank">Download Comparison Results</a>
                        </div>
                        <div v-for="(page, i) in doc.sideBySide" :key="'result-sbs-' + i" class="mb-4">
                          <div class="comparison-result-page">
                            <h4>Page {{ i + 1 }}</h4>
                            <b-table
                              :fields="fieldsSide"
                              :items="page"
                              class="custom-table-document"
                              striped
                            >
                              <template #cell(index)="row">
                                <pre>{{ row.index + 1 }}</pre>
                              </template>
                              <template #cell(doc1)="row">
                                <pre v-html="row.item.doc1.contents"></pre>
                              </template>
                              <template #cell(doc2)="row">
                                <pre v-html="row.item.doc2.contents"></pre>
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="mt-3 text-center">
                          <a v-if="doc.url" :href="$fileUrl + doc.urlSide" target="_blank">Download Comparison Results</a>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </CCol>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      originalDoc: null,
      compareDocs: [],
      fields: [
          { key: 'index', label: '#', thStyle: { width: '5%' } },
          { key: 'before', label: 'Before (Original)', thStyle: { width: '47.5%' } },
          { key: 'after', label: 'After (Scanned)', thStyle: { width: '47.5%' } },
      ],
      fieldsInline: [
          { key: 'index', label: '#', thStyle: { width: '5%' } },
          { key: 'contents', label: 'Contents', thStyle: { width: '95%' } }
      ],
      fieldsSide: [
          { key: 'index', label: '#', thStyle: { width: '5%' } },
          { key: 'doc1', label: 'Document 1', thStyle: { width: '47.5%' }, tdClass: this.cellType },
          { key: 'doc2', label: 'Document 2', thStyle: { width: '47.5%' }, tdClass: this.cellType },
      ],
      result: {},
      resultCompare: [],
      isShowResults: false,
      activeTab: 0,
    }
  },
  created() {

    this.isLoading = true
    this.result = {}
    this.resultCompare = []
    this.isShowResults = false
      
    let url = `/history/get-one?id=${this.$route.params.id}`

    this.$axios.get(url).then((response) => {
      if (response.status === 200 && response.data.success){
        let results = response.data.data
        this.result = results
        this.result.created_at = moment(this.result.created_at, "DD-MM-YYYY HH:mm:ss").add(this.$tzOffset, "minutes").locale("id").format("YYYY/MM/DD HH:mm:ss")
        this.result.finished_at = moment(this.result.finished_at, "DD-MM-YYYY HH:mm:ss").add(this.$tzOffset, "minutes").locale("id").format("YYYY/MM/DD HH:mm:ss")
        this.isShowResults = true
        if(results.result !== null){
          for(let i = 0; i < results.result.length; i++){
            this.resultCompare[i] = {
              isLoading: true,
              error: "",
              file1: "", 
              file2: "", 
              urlFile1: "",
              urlFile2: "",
              message: "",
              score:0, 
              url:"", 
              pages:[],
              inline:[],
              sideBySide:[]
            }
            this.analyzeDoc(results.result[i], i)
          }
        }
      }
      else {
        // if(!response.data.success && response.data.message) this.resultCompare[i].error = response.data.message
        // else this.resultCompare[i].error = "Terjadi kesalahan pada server. Silahkan coba lagi."
        // this.resultCompare[i].isLoading = false
        if(!response.data.success && response.data.message) this.errorLabel = response.data.message
        this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      }
    })
    .catch(error => {
      // if(error.response) this.resultCompare[i].error = error.response.data.reason
      // else this.resultCompare[i].error = "Terjadi kesalahan pada server. Silahkan coba lagi."
      // this.resultCompare[i].isLoading = false
      if(error.response) this.errorLabel = error.response.data.reason
      else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
      this.errorReload = false
      this.showErrorModal = true
    })
    .finally(() => {
      this.isLoading = false
      this.$forceUpdate()
    })

  },
  methods: {
    analyzeDoc(results, i){
      if(results.changes !== null) {
        let tempFileUrl = results.url_pdf.split("/")
        let tempFileUrlInline = results.url_pdf_inline.split("/")
        let tempFileUrlSide = results.url_pdf_sidebyside.split("/")
        tempFileUrl = tempFileUrl[tempFileUrl.length-1]
        tempFileUrlInline = tempFileUrlInline[tempFileUrlInline.length-1]
        tempFileUrlSide = tempFileUrlSide[tempFileUrlSide.length-1]
        if(!results.changes || results.changes.length <= 0) {
          this.resultCompare[i].isLoading = false
          this.resultCompare[i].file1 = results.file_1_name
          this.resultCompare[i].file2 = results.file_2_name
          this.resultCompare[i].urlFile1 = results.url_file_1
          this.resultCompare[i].urlFile2 = results.url_file_2
          this.resultCompare[i].message = results.message
          this.resultCompare[i].score = results.score
          this.resultCompare[i].url = tempFileUrl
          this.resultCompare[i].urlInline = tempFileUrlInline
          this.resultCompare[i].urlSide = tempFileUrlSide
        }
        else{
          // loop per page
          let page_rows = []
          let fnThis = this
          results.changes.forEach((function(page, index) {
            if(page.changes === null || page.changes.length == 0) {
              page_rows.push({ status:"MATCH", page:page.page_no, score:page.score, differences:[] })
            }
            else {
              // loop per sentences with difference
              let row_differences = []
              page.changes.forEach(function(row, i) {
                let before_sentence = ""
                let after_sentence = ""
                // loop per words in detected sentences
                row.words.forEach(function(current_word, j) {
                  if(current_word.type == "word") {
                    if(page.page_blank == "before"){
                      after_sentence += fnThis.escapeHtml(current_word.word)
                    }
                    else if(page.page_blank == "after"){
                      before_sentence += fnThis.escapeHtml(current_word.word)
                    }
                    else {
                      before_sentence += fnThis.escapeHtml(current_word.word)
                      after_sentence += fnThis.escapeHtml(current_word.word)
                    }
                  }
                  else if(current_word.type == "subtract") {
                    // before_sentence += `<span class="bg-danger correction-sub">` +current_word.word + `</span>`
                    before_sentence += `<span class="bg-danger correction-sub">` + fnThis.escapeHtml(current_word.word) + `</span>`
                  }
                  else if(current_word.type == "add") {
                    // after_sentence += `<span class="bg-success correction-add">` +current_word.word + `</span>`
                    after_sentence += `<span class="bg-success correction-add">` + fnThis.escapeHtml(current_word.word) + `</span>`
                  }
                })
                if(page.page_blank == "before"){
                  after_sentence = fnThis.escapeHtml(row.sentence_before) + after_sentence + fnThis.escapeHtml(row.sentence_after)
                }
                else if(page.page_blank == "after"){
                  before_sentence = fnThis.escapeHtml(row.sentence_before) + before_sentence + fnThis.escapeHtml(row.sentence_after)
                }
                else {
                  before_sentence = fnThis.escapeHtml(row.sentence_before) + before_sentence + fnThis.escapeHtml(row.sentence_after)
                  after_sentence = fnThis.escapeHtml(row.sentence_before) + after_sentence + fnThis.escapeHtml(row.sentence_after)
                }
                
                row_differences.push({ index: i+1, before: before_sentence, after: after_sentence })
                // rows += `<tr><td>` + (i + 1) + `</td><td>...` + before_sentence + `...</td><td>...` + after_sentence + `...</td></tr>`
              })
              page_rows.push({ status:"NOT MATCH", page:page.page_no, score:page.score, differences:row_differences })
            }
          }))
          this.resultCompare[i].isLoading = false
          this.resultCompare[i].file1 = results.file_1_name
          this.resultCompare[i].file2 = results.file_2_name
          this.resultCompare[i].urlFile1 = results.url_file_1
          this.resultCompare[i].urlFile2 = results.url_file_2
          this.resultCompare[i].message = results.message
          this.resultCompare[i].score = results.score
          this.resultCompare[i].url = tempFileUrl
          this.resultCompare[i].urlInline = tempFileUrlInline
          this.resultCompare[i].urlSide = tempFileUrlSide
          this.resultCompare[i].pages = page_rows
          this.resultCompare[i].inline = results.result_perline.map(item => {
            return {
              contents: item.inline_diff,
              type: ""
            }
          })
          let sbs = []
          let inl = []
          for(let i = 0; i < results.result_perline.length; i++){
            sbs[i] = []
            let itr = results.result_perline[i].doc1.content.length
            if(results.result_perline[i].doc2.content.length > itr) itr = results.result_perline[i].doc2.content.length
            let sbsdp1 = []
            for(let j = 0; j < results.result_perline[i].doc1.diff_pointer.length; j++){
              if(results.result_perline[i].doc1.diff_pointer[j].type == 'change'){
                results.result_perline[i].doc1.diff_pointer[j].type = 'min'
              }
              if(!sbsdp1[results.result_perline[i].doc1.diff_pointer[j].line]){
                sbsdp1[results.result_perline[i].doc1.diff_pointer[j].line] = {
                  indices: [],
                  type: results.result_perline[i].doc1.diff_pointer[j].type
                }
              }
              for(let k = 0; k < results.result_perline[i].doc1.diff_pointer[j].indexes.length; k++){
                sbsdp1[results.result_perline[i].doc1.diff_pointer[j].line].indices.push(results.result_perline[i].doc1.diff_pointer[j].indexes[k])
              }
              sbsdp1[results.result_perline[i].doc1.diff_pointer[j].line].indices.sort((a, b) => {
                return a[0] - b[0]
              })
            }
            let sbsdp2 = []
            for(let j = 0; j < results.result_perline[i].doc2.diff_pointer.length; j++){
              if(results.result_perline[i].doc2.diff_pointer[j].type == 'change'){
                results.result_perline[i].doc2.diff_pointer[j].type = 'add'
              }
              if(!sbsdp2[results.result_perline[i].doc2.diff_pointer[j].line]){
                sbsdp2[results.result_perline[i].doc2.diff_pointer[j].line] = {
                  indices: [],
                  type: results.result_perline[i].doc2.diff_pointer[j].type
                }
              }
              for(let k = 0; k < results.result_perline[i].doc2.diff_pointer[j].indexes.length; k++){
                sbsdp2[results.result_perline[i].doc2.diff_pointer[j].line].indices.push(results.result_perline[i].doc2.diff_pointer[j].indexes[k])
              }
              sbsdp2[results.result_perline[i].doc2.diff_pointer[j].line].indices.sort((a, b) => {
                return a[0] - b[0]
              })
            }
            for(let j = 0; j < itr; j++){
              let item1 = results.result_perline[i].doc1.content[j] ? results.result_perline[i].doc1.content[j] : ""
              let item2 = results.result_perline[i].doc2.content[j] ? results.result_perline[i].doc2.content[j] : ""
              if(sbsdp1[j] && sbsdp1[j].indices){
                for(let k = sbsdp1[j].indices.length - 1; k >= 0; k--){
                  item1 = item1.substring(0, sbsdp1[j].indices[k][0]) + (sbsdp1[j].type == 'add' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item1.substring(sbsdp1[j].indices[k][0], sbsdp1[j].indices[k][1]) + "</span>" + item1.substring(sbsdp1[j].indices[k][1])
                  // item = item.substring(0, indices[k].idx) + (indices[k].type == 'green' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item[indices[k].idx] + '</span>' + item.substring(indices[k].idx + 1)
                }
              }
              if(sbsdp2[j] && sbsdp2[j].indices){
                for(let k = sbsdp2[j].indices.length - 1; k >= 0; k--){
                  item2 = item2.substring(0, sbsdp2[j].indices[k][0]) + (sbsdp2[j].type == 'add' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item2.substring(sbsdp2[j].indices[k][0], sbsdp2[j].indices[k][1]) + "</span>" + item2.substring(sbsdp2[j].indices[k][1])
                  // item = item.substring(0, indices[k].idx) + (indices[k].type == 'green' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item[indices[k].idx] + '</span>' + item.substring(indices[k].idx + 1)
                }
              }
              sbs[i][j] = {
                doc1: { contents: item1, type: "" },
                doc2: { contents: item2, type: "" }
              }
              if (item1.charAt(0) === '+' && item1.charAt(1) === ' '){
                sbs[i][j].doc1.contents = sbs[i][j].doc1.contents.substring(2)
                sbs[i][j].doc1.type = "green"
              }
              if (item1.charAt(0) === '-' && item1.charAt(1) === ' '){
                sbs[i][j].doc1.contents = sbs[i][j].doc1.contents.substring(2)
                sbs[i][j].doc1.type = "red"
              }
              if (item2.charAt(0) === '+' && item2.charAt(1) === ' '){
                sbs[i][j].doc2.contents = sbs[i][j].doc2.contents.substring(2)
                sbs[i][j].doc2.type = "green"
              }
              if (item2.charAt(0) === '-' && item2.charAt(1) === ' '){
                sbs[i][j].doc2.contents = sbs[i][j].doc2.contents.substring(2)
                sbs[i][j].doc2.type = "red"
              }
            }
            inl[i] = []
            for(let j = 0; j < results.result_perline[i].inline_diff.length;){
              let item = results.result_perline[i].inline_diff[j]
              if(item.charAt(0) === '+' && item.charAt(1) === ' '){
                if(j+1 < results.result_perline[i].inline_diff.length){
                  let next = results.result_perline[i].inline_diff[j+1]
                  if(next.charAt(0) === '?' && next.charAt(1) === ' '){
                    let indices = []
                    for(let k=0; k<next.length;k++) {
                      if (next[k] === "+"){
                        indices.push({idx:k, type:"green"})
                      }
                      if (next[k] === "-"){
                        indices.push({idx:k, type:"red"})
                      }
                      if (next[k] === "^"){
                        indices.push({idx:k, type:"green"})
                      }
                    }
                    results.result_perline[i].inline_diff.splice(j+1, 1)
                    for(let k = indices.length - 1; k >= 0; k--){
                      item = item.substring(0, indices[k].idx) + (indices[k].type == 'green' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item[indices[k].idx] + '</span>' + item.substring(indices[k].idx + 1)
                    }
                  }
                }
                item = item.substring(2)
                // item = item.replace(/ /g, '\xa0')
                inl[i][j] = {
                  contents: item,
                  type: "add"
                }
                j++
              }
              else if(item.charAt(0) === '-' && item.charAt(1) === ' '){
                if(j+1 < results.result_perline[i].inline_diff.length){
                  let next = results.result_perline[i].inline_diff[j+1]
                  if(next.charAt(0) === '?' && next.charAt(1) === ' '){
                    let indices = []
                    for(let k=0; k<next.length;k++) {
                      if (next[k] === "+"){
                        indices.push({idx:k, type:"green"})
                      }
                      if (next[k] === "-"){
                        indices.push({idx:k, type:"red"})
                      }
                      if (next[k] === "^"){
                        indices.push({idx:k, type:"red"})
                      }
                    }
                    results.result_perline[i].inline_diff.splice(j+1, 1)
                    for(let k = indices.length - 1; k >= 0; k--){
                      item = item.substring(0, indices[k].idx) + (indices[k].type == 'green' ? '<span class="bg-highlight-green">' : '<span class="bg-highlight-red">') + item[indices[k].idx] + '</span>' + item.substring(indices[k].idx + 1)
                    }
                  }
                }
                item = item.substring(2)
                // item = item.replace(/ /g, '\xa0')
                inl[i][j] = {
                  contents: item,
                  type: "remove"
                }
                j++
              }
              else{
                // item = item.replace(/ /g, '\xa0')
                inl[i][j] = {
                  contents: item,
                  type: ""
                }
                j++
              }
            }
          }
          this.resultCompare[i].sideBySide = sbs
          this.resultCompare[i].inline = inl
          console.log(this.resultCompare[i])
        }
      }
      else {
        if(results.message) this.resultCompare[i].message = results.message
        else this.resultCompare[i].message = "Document Failed to Analyze."
        this.resultCompare[i].file1 = results.file_1_name
        this.resultCompare[i].file2 = results.file_2_name
        this.resultCompare[i].urlFile1 = results.url_file_1
        this.resultCompare[i].urlFile2 = results.url_file_2
        this.resultCompare[i].score = results.score
        this.resultCompare[i].isLoading = false
      }
    },
    rowType(item, type){
      if(item && type === 'row'){
        if(item.type == 'add'){
          return "custom-tr-green"
        }
        else if(item.type == 'remove'){
          return "custom-tr-red"
        }
        else{
          return ""
        }
      }
    },
    cellType(value, key, item){
      if(value.type == 'green') return 'custom-tr-green'
      if(value.type == 'red') return 'custom-tr-red'
      return ''
    },
    escapeHtml(unsafe){
      return unsafe
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#039;")
    }
  }
}
</script>